import { Circle, createIcon } from './index';

export const IconDot = createIcon({
  title: 'A dot.',
  viewBox: '0 0 24 24',
  path: [<Circle cx="12" cy="12" r="4" fill="currentColor" />],
});
